module.exports = __webpack_public_path__ + "static/media/back-chevron-brand-refresh.f2212977.svg";